import React from 'react'
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'

class SketchExample extends React.Component {
    state = {
        displayColorPicker: false,
        color: {
            r: '0',
            g: '0',
            b: '0',
            a: '1',
        },
    };

    componentWillReceiveProps(nextProps) {
        if (this.props.color !== nextProps.color) {
            const { r, g, b } = this.hexToRGB(nextProps.color)
            this.setState({
                color: {
                    r: r, g: g, b: b, a: '1'
                }
            })
        }
    }

    componentDidMount() {
        const { r, g, b } = this.hexToRGB(this.props.color)
        this.setState({
            color: {
                r: r, g: g, b: b, a: '1'
            }
        })
    }


    hexToRGB(hex) {
        if (hex) {
            var r = parseInt(hex.slice(1, 3), 16),
                g = parseInt(hex.slice(3, 5), 16),
                b = parseInt(hex.slice(5, 7), 16);

            return {
                r: r,
                g: g,
                b: b,
                a: 1
            }
        } else {
            return { r: '', g: '', b: '', a: '' }
        }
    }


    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false })
    };

    handleChange = (color) => {
        this.setState({ color: color.rgb })
        this.props && this.props.onChange && this.props.onChange(color.hex)
    };

    render() {
        const styles = reactCSS({
            'default': {
                color: {
                    width: '36px',
                    height: '14px',
                    borderRadius: '2px',
                    background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
                },
                swatch: {
                    padding: '5px',
                    background: '#fff',
                    borderRadius: '1px',
                    boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
                    display: 'inline-block',
                    cursor: 'pointer',
                },
                popover: {
                    position: 'absolute',
                    zIndex: '2',
                },
                cover: {
                    position: 'fixed',
                    top: '0px',
                    right: '0px',
                    bottom: '0px',
                    left: '0px',
                },
            },
        });

        return (
            <div>
                <div style={styles.swatch} onClick={this.handleClick}>
                    <div style={styles.color} />
                </div>
                {this.state.displayColorPicker ? <div style={styles.popover}>
                    <div style={styles.cover} onClick={this.handleClose} />
                    <SketchPicker color={this.state.color} onChange={this.handleChange} />
                </div> : null}

            </div>
        )
    }
}

export default SketchExample